import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/signup_icons/logo-dark.svg";
import google from "../assets/images/signup_icons/google-color.svg";
import facebook from "../assets/images/signup_icons/face.svg";
import personicon from "../assets/images/signup_icons/personicon.svg";
import emailicon from "../assets/images/signup_icons/email.svg";
import lockicon from "../assets/images/signup_icons/lock.svg";
import classes from "../assets/styles/Signup.module.css";
import FormInput from "../components/Forms/FormInput";
import {
  COUPON_SIGNUP,
  LINKEDIN_AUTH,
  SIGNUP,
  TEAM_OWNER_SIGNUP,
} from "../utils/constants/apiUrl";
import { get, post } from "../server";
import { useAtom } from "jotai";
import { loggedInUser, isOwnerPackage } from "../utils/store";
import { useNavigate, useLocation } from "react-router-dom";
import {
  UserSignupSchema,
  TeamOwnerSignupSchema,
} from "../utils/SchemasValidation/SignupSchema";
import ValidateSchema from "../helpers/ValidateSchema";
import showToast from "../helpers/showToast";
import Loader from "../components/Loader";
import { useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import _ from "lodash";
import { logoutFbApi } from "../utils/functions";
import useFunctionsCount from "../hooks/useFunctionsCount";
import AuthModal from "../components/Modals/AuthModal";
import useLogout from "../hooks/useLogout";
import { trackEvent } from "../utils/mixpanel";
import { Button } from "react-bootstrap";
import { BsLinkedin } from "react-icons/bs";

const Signup = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const coupon = searchParams.get("coupon");

  const uuid = searchParams.get("uuid");
  const team_id = searchParams.get("team_id");
  const email = searchParams.get("email");
  console.log("sdagv", coupon);
  let emptyObj = {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
    coupon_code_id: coupon || null,
  };
  const logout = useLogout();

  let navigate = useNavigate();

  const { userActions } = useFunctionsCount();

  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [isOwnerPackageActive, setIsOwnerPackageActive] =
    useAtom(isOwnerPackage);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [user, setUser] = useState(emptyObj);
  const [teamOwner, setTeamOwner] = useState({
    team_name: "",
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
    coupon_code_id: coupon || null,
  });

  const [key, setKey] = useState("individual");

  const [showAuthModal, setShowAuthModal] = useState(false);
  const [isTeamOwner, setIsTeamOwner] = useState(false);
  const [socialTeamOwner, setSocialTeamOwner] = useState({ team_name: "" });

  const handleCloseModal = () => {
    setShowAuthModal(false);
  };

  useEffect(() => {
    if (email) {
      setUser({ ...user, email: email });
    }
  }, [email]);

  // const handleChange = (e) => {
  //   if (key === "individual") {
  //     const name = e.target.name;
  //     const value = e.target.value.trim();
  //     setUser({ ...user, [name]: value });
  //   } else {
  //     const name = e.target.name;
  //     const value = e.target.value;
  //     setTeamOwner({ ...teamOwner, [name]: value });
  //   }
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.trim();

    // Update the relevant state based on the selected tab (individual or team)
    if (key === "individual") {
      // setUser((prev) => ({ ...prev, [name]: trimmedValue }));

      // Validate the specific field and clear the error for that field if valid
      const updatedUser = { ...user, [name]: trimmedValue };
      setUser(updatedUser);

      const fieldErrors = ValidateSchema(updatedUser, UserSignupSchema);
      setErrors((prevErrors) => ({ ...prevErrors, [name]: fieldErrors[name] }));
    } else {
      // setTeamOwner((prev) => ({ ...prev, [name]: trimmedValue }));

      // // Validate and clear errors for team owner fields
      // const fieldErrors = ValidateSchema(
      //   { [name]: trimmedValue },
      //   TeamOwnerSignupSchema
      // );
      // setErrors((prevErrors) => ({ ...prevErrors, [name]: fieldErrors[name] }));
      const updatedTeamOwner = { ...teamOwner, [name]: trimmedValue };
      setTeamOwner(updatedTeamOwner);

      const fieldErrors = ValidateSchema(
        updatedTeamOwner,
        TeamOwnerSignupSchema
      );
      setErrors((prevErrors) => ({ ...prevErrors, [name]: fieldErrors[name] }));
    }
  };

  const validateForm = () => {
    if (key === "individual") {
      let newErrors = ValidateSchema(user, UserSignupSchema);
      setErrors(newErrors);
      if (Object.keys(newErrors).length) return false;
      return true;
    } else {
      let newErrors = ValidateSchema(teamOwner, TeamOwnerSignupSchema);
      setErrors(newErrors);
      if (Object.keys(newErrors).length) return false;
      return true;
    }
  };
  const couponVal = location?.state?.couponVal;
  console.log("couponVal-----", couponVal);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsOwnerPackageActive(false);
    setLoading(true);
    if (key === "individual") {
      let payload = _.cloneDeep(user);
      if (uuid && team_id) {
        payload.uuid = uuid;
        payload.team_id = team_id;
      }
      console.log("payload", payload);
      trackEvent("Signup Form Submitted", {
        data: payload,
      });
      let API = couponVal < 100 || coupon === null ? SIGNUP : COUPON_SIGNUP;
      let { status, message, data } = await post(API, payload);
      if (status) {
        // mixpanel.track("Signup Successful", {
        //   user_type: key,
        //   email: key === "individual" ? user.email : teamOwner.email,
        // });
        trackEvent("Signup Successful", {
          data: data,
        });
        if (
          email &&
          loggedUser?.email?.length > 0 &&
          loggedUser?.email !== email
        ) {
          logout();
          setLoggedUser(data);
          userActions(data);
          const couponData = data;
          console.log("data-------->>>>>>>>>>>", data);
          if (couponVal < 100 || coupon === null) {
            navigate("/");
            showToast(status, message);
          } else {
            // if(data?.coupon?.discount === 100 && data?.subscription !== null){}
            navigate("/share/coupon-message", {
              state: { coupon: data },
            });
          }
        } else {
          setLoggedUser(data);
          userActions(data);
          const couponData = data;

          console.log("data-------->>>>>>>>>>>", data);
          if (couponVal < 100 || coupon === null) {
            navigate("/individualSubscription");
            showToast(status, message);
          } else {
            // if(data?.coupon?.discount === 100 && data?.subscription !== null){}
            navigate("/share/coupon-message", {
              state: { coupon: couponData },
            });
          }
        }
      }
    } else {
      let { status, message, data } = await post(TEAM_OWNER_SIGNUP, teamOwner);
      if (status) {
        // mixpanel.track("Signup Successful", {
        //   user_type: key,
        //   email: key === "individual" ? user.email : teamOwner.email,
        // });
        trackEvent("Signup Successful", {
          data: data,
        });
        logout();
        setLoggedUser(data);
        userActions(data);
        navigate("/");
      } else {
        setLoggedUser(data);
        userActions(data);
        navigate("/subscription", { replace: true });
      }

      if (!status) {
        showToast(status, message);
      }
    }
    setLoading(false);
  };
  // const loginButton = useGoogleLogin({
  //   onSuccess: (codeResponse) => {
  //     fetch(
  //       `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${codeResponse.access_token}`
  //     )
  //       .then((res) => {
  //         return res.json();
  //       })
  //       .then(async (users) => {
  //         return await sendSocialToken(users);
  //       })
  //       .catch((error) => {
  //         showToast(false, error);
  //         setLoading(false);
  //         return;
  //       });
  //   },
  //   onError: (err) => {
  //     setLoading(false);
  //     showToast(false, err);
  //   },
  // });
  const handleSocialLogin = (buttonName) => {
    trackEvent(buttonName);
    loginButton(); // trigger the actual login
  };
  const loginButton = useGoogleLogin({
    onSuccess: (codeResponse) => {
      fetch(
        `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${codeResponse.access_token}`
      )
        // .log("codeResponse.access_token", codeResponse.access_token)
        .then((res) => {
          return res.json();
        })
        .then(async (users) => {
          return await sendSocialToken(users);
        })
        .catch((error) => {
          showToast(false, error);
          setLoading(false);
          return;
        });
    },
    onError: (err) => {
      setLoading(false);
      showToast(false, err);
    },
  });

  const sendSocialToken = async (user) => {
    setLoading(true);

    let payload = user;
    payload.first_name = user.given_name;
    payload.last_name = user.family_name;
    payload.token = user.sub;
    payload.provider_type = "google";
    payload.coupon_code_id = coupon || null;
    console.log("payload", payload);
    if (uuid && team_id) {
      payload.uuid = uuid;
      payload.team_id = team_id;
    }

    if (uuid && team_id) {
      if (payload.email === email) {
        trackEvent(
          `${
            payload.provider_type === "google" ? "Google" : "Facebook"
          } Login Successfully`,
          {
            data: user,
          }
        );
        navigate(
          `/socialSignup?first_name=${payload.first_name}&last_name=${
            payload.last_name
          }&socialEmail=${payload.email}&is_team_owner=${
            key === "individual" ? false : true
          }&token=${payload.token}&provider_type=${payload.provider_type}${
            uuid && team_id && `&uuid=${uuid}&team_id=${team_id}`
          }`
        );
      } else {
        trackEvent(
          `${
            payload.provider_type === "google" ? "Google" : "Facebook"
          } Login Failed`,
          {
            data: user,
          }
        );
        showToast(false, "Invitation email and social emails do not match");
        setLoading(false);
        return;
      }
    } else {
      navigate(
        `/socialSignup?first_name=${payload.first_name}&last_name=${
          payload.last_name
        }&socialEmail=${payload.email}&is_team_owner=${
          key === "individual" ? false : true
        }&token=${payload.token}&provider_type=${
          payload.provider_type
        }&coupon=${coupon}`
      );
    }

    setLoading(false);
  };

  const responseFacebook = async (response) => {
    // check error
    if (response?.error?.message) {
      showToast(false, response.error.message);
      return;
    }

    if (!response.id) {
      showToast(false, "Authentication faild");
      logoutFbApi();
      return;
    }

    setLoading(true);
    let payload = response;

    const email = response.email || response.emails?.[0]?.value || "";
    const birthday = response.birthday || "";
    const gender = response.gender || "";
    const profileLink = response.link || "";

    if (response?.name) {
      let dataName = handleFaceBookName(response?.name);
      if (dataName.length > 0) {
        payload.first_name = dataName["0"];
        payload.last_name = dataName?.["1"];
        payload.email = dataName?.["2"] || email;
      }
    }
    payload.gender = gender;
    payload.token = payload.id;
    payload.provider_type = "facebook";
    payload.coupon_code_id = coupon || null;

    delete payload.id;

    if (uuid && team_id) {
      payload.uuid = uuid;
      payload.team_id = team_id;
    }

    if (uuid && team_id) {
      trackEvent(
        `${
          payload.provider_type === "google" ? "Google" : "Facebook"
        } Login Successfully`,
        {
          data: user,
        }
      );
      if (!payload.email.length > 0) {
        navigate(
          `/socialSignup?first_name=${payload.first_name.replace(
            /\s/g,
            ""
          )}&last_name=${payload.last_name.replace(
            /\s/g,
            ""
          )}&socialEmail=${email}&is_team_owner=${
            key === "individual" ? false : true
          }&token=${payload.token}&provider_type=${payload.provider_type}${
            uuid && team_id && `&uuid=${uuid}&team_id=${team_id}`
          }`
        );
      } else if (payload.email === email) {
        navigate(
          `/socialSignup?first_name=${payload.first_name.replace(
            /\s/g,
            ""
          )}&last_name=${payload.last_name.replace(/\s/g, "")}&socialEmail=${
            payload.email
          }&is_team_owner=${key === "individual" ? false : true}&token=${
            payload.token
          }&provider_type=${payload.provider_type}${
            uuid && team_id && `&uuid=${uuid}&team_id=${team_id}`
          }`
        );
      } else {
        showToast(false, "Invitation email and social emails do not match");
        setLoading(false);
        return;
      }
    } else {
      trackEvent(
        `${
          payload.provider_type === "google" ? "Google" : "Facebook"
        } Login Successfully`,
        {
          data: user,
        }
      );
      navigate(
        `/socialSignup?first_name=${payload.first_name.replace(
          /\s/g,
          ""
        )}&last_name=${payload.last_name.replace(/\s/g, "")}&socialEmail=${
          payload.email
        }&is_team_owner=${key === "individual" ? false : true}&token=${
          payload.token
        }&provider_type=${payload.provider_type}`
      );
    }
    setLoading(false);
  };

  const handleFaceBookName = (str) => {
    if (str) {
      let lastString = str.trim().split(" ").slice(-1);
      if (lastString.length > 0) {
        let firstName = str.replace(lastString["0"], "");
        let nameArr = [];
        nameArr.push(firstName, lastString["0"]);
        return nameArr;
      }
    }
    return [];
  };

  // LinkedInLoginButton.jsx
  // const LINKEDIN_CLIENT_ID = "782nmbn7ug2fdb";
  // // use a clear callback path instead of root
  // const REDIRECT_URI = "http://localhost:3000/auth/linkedin/callback";

  // const handleLinkedinLogin = () => {
  //   const state = Math.random().toString(36).substring(7);
  //   const scope = "openid profile email";

  //   const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${LINKEDIN_CLIENT_ID}&redirect_uri=${encodeURIComponent(
  //     REDIRECT_URI
  //   )}&state=${state}&scope=${encodeURIComponent(scope)}`;

  //   console.log("LinkedIn authUrl:", authUrl); // <-- debug line
  //   window.location.href = authUrl;
  // };

  const handleLinkedinLogin = async () => {
    setLoading(true);
    let { status, message, data } = await get(LINKEDIN_AUTH);
    if (status) {
      console.log("data-------->>>>>>>>>>>", data);

      window.open(data?.url, "_blank", "noopener,noreferrer");
    }
    setLoading(false);
  };

  return (
    <>
      <section className="auth-page">
        {!loading ? (
          <div className="container-fluid h-100">
            <div className="row h-100 align-items-center">
              <div className="col-12 col-md-6 col-lg-6 d-flex justify-content-center align-items-center left-panel">
                <div className="left-panel-inner">
                  <img src={logo} alt="logo" className="logo mb-4" />
                  {/* <h1 className="heading">Hello, Welcome Back</h1> */}
                  <p className="subHeading">
                    Experience the future of networking with us, and together,
                    let’s “Connect. Share. Inspire.”
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-6 right-panel d-flex justify-content-center align-items-center">
                <div className="right-panel-inner">
                  <h1>Create account</h1>
                  <p>Please enter your details to create an account.</p>
                  <div className="d-grid gap-3 social-login">
                    <Button
                      className="google-btn text-center text-decoration-none"
                      onClick={() => {
                        handleSocialLogin("Google SignUp Button Clicked");
                      }}
                    >
                      <img src={google} alt="Google" className="icon" /> Sign Up
                      with Google
                    </Button>
                    <FacebookLogin
                      // appId="3507512309478815"
                      appId="956908413125623"
                      //appId="292102873859116" // for testing
                      autoLoad={false}
                      fields="name,email,birthday,picture,gender,link"
                      scope="public_profile,email,user_birthday,user_gender,user_link"
                      callback={responseFacebook}
                      render={(renderProps) => (
                        <Button
                          className="apple-btn" // onClick={renderProps.onClick}
                          onClick={() => {
                            renderProps.onClick();
                            trackEvent("Facebook Button Clicked");
                          }}
                        >
                          <img src={facebook} alt="Apple" className="icon" />{" "}
                          Sign Up with Facebook
                        </Button>
                      )}
                    />
                    {/* <Button
                      onClick={handleLinkedinLogin}
                      className="google-btn text-center text-decoration-none mt-0"
                    >
                      <BsLinkedin /> Login with LinkedIn
                    </Button> */}
                  </div>
                  <div className="or-devider devider-sg">
                    <span>OR</span>
                  </div>
                  <Tabs
                    defaultActiveKey="individual"
                    id="uncontrolled-tab-example"
                    className="customSignuUpPageTabs"
                    transition={false}
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                  >
                    <Tab eventKey="individual" title="As an Individual">
                      <form>
                        <div className="row gx-3">
                          <div className="col-12 col-md-6">
                            <FormInput
                              // label="First Name"
                              type="text"
                              placeholder="First Name"
                              name="first_name"
                              value={user.first_name}
                              handleChange={handleChange}
                              error={errors?.first_name}
                              // icon={personicon}
                              autofocus={true}
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <FormInput
                              // label="Last Name"
                              type="text"
                              placeholder="Last Name"
                              name="last_name"
                              value={user.last_name}
                              handleChange={handleChange}
                              error={errors?.last_name}
                              // icon={personicon}
                            />
                          </div>
                        </div>
                        <FormInput
                          // label="Email"
                          type="text"
                          name="email"
                          placeholder="Email Address"
                          value={user.email}
                          handleChange={handleChange}
                          error={errors?.email}
                          // icon={emailicon}
                          disabled={email ? true : false}
                        />
                        <div className="row gx-3">
                          <div className="col-12 col-md-6">
                            <FormInput
                              // label="Password"
                              type="password"
                              name="password"
                              placeholder="Password"
                              value={user.password}
                              handleChange={handleChange}
                              error={errors?.password}
                              // icon={lockicon}
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <FormInput
                              // label="Confirm Password"
                              type="password"
                              name="confirm_password"
                              placeholder="Confirm Password"
                              value={user.confirm_password}
                              handleChange={handleChange}
                              error={errors?.confirm_password}
                              // icon={lockicon}
                            />
                          </div>
                        </div>

                        <Button
                          variant="primary"
                          className="btn-block w-100"
                          type="submit"
                          onClick={handleSubmit}
                        >
                          Create account
                        </Button>
                      </form>
                    </Tab>
                    {coupon === null && !team_id && (
                      <Tab eventKey="teamowner" title="As a Team Owner">
                        <form>
                          <FormInput
                            // label="Email"
                            type="text"
                            name="team_name"
                            placeholder="Team Name"
                            value={teamOwner.team_name}
                            handleChange={handleChange}
                            error={errors?.team_name}
                            // icon={personicon}
                            autofocus={true}
                          />
                          <div className="row gx-3">
                            <div className="col-12 col-md-6">
                              <FormInput
                                // label="First Name"
                                type="text"
                                placeholder="First Name"
                                name="first_name"
                                value={teamOwner.first_name}
                                handleChange={handleChange}
                                error={errors?.first_name}
                                // icon={personicon}
                              />
                            </div>
                            <div className="col-12 col-md-6">
                              <FormInput
                                // label="Last Name"
                                type="text"
                                placeholder="Last Name"
                                name="last_name"
                                value={teamOwner.last_name}
                                handleChange={handleChange}
                                error={errors?.last_name}
                                // icon={personicon}
                              />
                            </div>
                          </div>

                          <FormInput
                            // label="Email"
                            type="text"
                            name="email"
                            placeholder="Email Address"
                            value={teamOwner.email}
                            handleChange={handleChange}
                            error={errors?.email}
                            // icon={emailicon}
                          />
                          <div className="row gx-3">
                            <div className="col-12 col-md-6">
                              <FormInput
                                // label="Password"
                                type="password"
                                name="password"
                                placeholder="Password"
                                value={teamOwner.password}
                                handleChange={handleChange}
                                error={errors?.password}
                                // icon={lockicon}
                              />
                            </div>
                            <div className="col-12 col-md-6">
                              <FormInput
                                // label="Confirm Password"
                                type="password"
                                name="confirm_password"
                                placeholder="Confirm Password"
                                value={teamOwner.confirm_password}
                                handleChange={handleChange}
                                error={errors?.confirm_password}
                                // icon={lockicon}
                              />
                            </div>
                          </div>
                          <div className={classes.submitBtnWrapper}>
                            <Button
                              variant="primary"
                              className="btn-block w-100"
                              type="submit"
                              onClick={handleSubmit}
                            >
                              Continue
                            </Button>
                          </div>
                        </form>
                      </Tab>
                    )}
                  </Tabs>
                  <div className="notAccountWrapper mt-4">
                    <p className="mb-3">Already have an account?</p>
                    <Link
                      to="/login"
                      onClick={() => trackEvent("Sign In Button Clicked")}
                    >
                      <Button
                        variant="outline-primary"
                        className="btn-block w-100"
                      >
                        Sign In
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </section>

      <AuthModal
        show={showAuthModal}
        handleCloseModal={handleCloseModal}
        isTeamOwner={isTeamOwner}
        setSocialTeamOwner={setSocialTeamOwner}
        socialTeamOwner={socialTeamOwner}
      />
    </>
  );
};

export default Signup;
